import { ButtonBase } from "@mui/material";
import { useEffect, useState } from "react";

import "./switch-box.css";

const SwitchBox = (props) => {
    const { title, tabs, value, disabled } = props;
    const [tabIdx, setTabIdx] = useState(0);

    const handleSwitch = (idx, tabId) => {
        setTabIdx(idx);
        if (props.settingsHandle) {
            props.settingsHandle(idx, title?.toLowerCase(), tabId);
        }
    };

    useEffect(() => {
        setTabIdx(0);
    }, [tabs]);

    return (
        <div className="switch-box">
            {title && <label>{title}</label>}
            <div className="switch-body">
                {tabs.map((tab, idx) => (
                    <ButtonBase
                        key={idx}
                        disabled={disabled ? true : tab.disabled ? true : false}
                    >
                        <span
                            className={`switch ${value !== undefined
                                ? value == tab.id && "active"
                                : tabIdx == idx && "active"
                                }`}
                            onClick={() => handleSwitch(idx, tab.id)}
                        >
                            {tab.name}
                        </span>
                    </ButtonBase>
                ))}
            </div>
        </div>
    );
};

export default SwitchBox;
